<script lang="ts" setup>
import { usePanelStore } from '~/store/spot/panel'

const { t } = useI18n()
const panel = usePanelStore()
const sides = computed(() => [
  { label: t('买入'), value: 'BUY', class: 'bg-buy text-textWhiteStatic' },
  { label: t('卖出'), value: 'SELL', class: 'bg-sell text-textWhiteStatic' },
])
</script>

<template>
  <div class="flex font-medium rounded-lg cursor-pointer bg-pageTertiary h-[34px] p-[1px] text-textTertiary">
    <div
      v-for="i in sides" :key="i.value" class="flex items-center justify-center h-full px-3 rounded-lg w-1/2" :class="{
        [i.class]: i.value === panel.side,
      }" @click="panel.side = i.value"
    >
      {{ i.label }}
    </div>
  </div>
</template>
